module.exports = [
  {
    "name": "Awesome Lists",
    "key": "awesome-lists",
    "aka": [
      "nice lists",
      "cool lists",
      "pretty good lists"
    ],
    "description": "Lists of awesome things - JavaScript focus only.",
    "count": 6,
    "type": "PROJECT"
  },
  {
    "name": "Bundlers",
    "key": "bundlers",
    "aka": [
      "JavaScript bundlers",
      "packagers"
    ],
    "description": "These are tools that transform JS and CSS. They are typically highly configurable and pluggable.",
    "count": 4,
    "type": "PROJECT"
  },
  {
    "name": "Developer Tools",
    "key": "devtools",
    "aka": [
      "dev tools"
    ],
    "description": "Tools used by developers while building JavaScript applications.",
    "count": 18,
    "type": "PROJECT"
  },
  {
    "name": "Email Tools",
    "key": "email-tools",
    "aka": [
      "other",
      "unknown"
    ],
    "description": "Tools that are useful for creating, designing, or sending email in JavaScript.",
    "count": 5,
    "type": "PROJECT"
  },
  {
    "name": "Error",
    "key": "error",
    "aka": [
      "fail"
    ],
    "description": "Projects I wasn't able to parse for one reason or another.",
    "count": 21,
    "type": "PROJECT"
  },
  {
    "name": "State Managers",
    "key": "state-managers",
    "aka": [
      "flux libraries"
    ],
    "description": "These manage the state of your JavaScript application.",
    "count": 26,
    "type": "PROJECT"
  },
  {
    "name": "Interesting",
    "key": "interesting",
    "aka": [
      "other",
      "unknown"
    ],
    "description": "These are things that I couldn't categorize but that I find interesting. Hopefully I find a place on the site for all of these things eventually.",
    "count": 29,
    "type": "PROJECT"
  },
  {
    "name": "JavaScript Tutorials",
    "key": "javascript-tutorials",
    "aka": [
      ""
    ],
    "description": "",
    "count": 2,
    "type": "PROJECT"
  },
  {
    "name": "Linters",
    "key": "linters",
    "aka": [
      "code formatters",
      "beautifiers",
      "prettifiers"
    ],
    "description": "Linters find potential errors and/or formatting inconsistencies in your code. Some will automatically fix your code for you.",
    "count": 13,
    "type": "PROJECT"
  },
  {
    "name": "Loggers",
    "key": "loggers",
    "aka": [
      "logging libraries"
    ],
    "description": "Utilities that help you log useful information to the console (or elsewhere). These are alternatives to \"console.log\".",
    "count": 7,
    "type": "PROJECT"
  },
  {
    "name": "Networking Libraries",
    "key": "networking-libraries",
    "aka": [
      "AJAX libraries"
    ],
    "description": "Tool that assist with making networking or AJAX calls",
    "count": 9,
    "type": "PROJECT"
  },
  {
    "name": "React Components",
    "key": "react-components",
    "aka": [
      "React Component Libraries",
      "React UI Frameworks"
    ],
    "description": "The building blocks of React apps. These are components that you can use in your own apps.",
    "count": 213,
    "type": "PROJECT"
  },
  {
    "name": "React Example Apps",
    "key": "react-example-apps",
    "aka": [
      "react sample code",
      "react sample apps"
    ],
    "description": "Open-source apps that use React.",
    "count": 197,
    "type": "PROJECT"
  },
  {
    "name": "React Starter Projects",
    "key": "react-starter-projects",
    "aka": [
      "react boilerplates",
      "react starters",
      "react seeds"
    ],
    "description": "Repositories that you can copy and modify to create your own React app.",
    "count": 198,
    "type": "PROJECT"
  },
  {
    "name": "React Tutorials",
    "key": "react-tutorials",
    "aka": [
      "react walkthroughs",
      "react getting started",
      "react guides"
    ],
    "description": "Articles that walk you through completing a task with React, step-by-step.",
    "count": 7,
    "type": "ARTICLE"
  },
  {
    "name": "Static Site Generators",
    "key": "static-site-generators",
    "aka": [
      "static site builder",
      "static site framework"
    ],
    "description": "Tools that help you generate a static site.",
    "count": 18,
    "type": "PROJECT"
  },
  {
    "name": "Style Libraries",
    "key": "style-libraries",
    "aka": [
      "css processors",
      "style utilities",
      "stylers"
    ],
    "description": "Tools that assist you with applying CSS to your components or HTML.",
    "count": 24,
    "type": "PROJECT"
  },
  {
    "name": "Test Utilities",
    "key": "test-utilities",
    "aka": [
      "test frameworks",
      "test tools"
    ],
    "description": "Tools that help you test your app.",
    "count": 15,
    "type": "PROJECT"
  },
  {
    "name": "Utility Libraries",
    "key": "utility-libraries",
    "aka": [
      "lodash alternatives",
      "jquery alternatives",
      "underscore alternatives"
    ],
    "description": "Each of these libraries contain many functions that are meant to help with a variety of common tasks in JavaScript.",
    "count": 7,
    "type": "PROJECT"
  },
  {
    "name": "View Libraries",
    "key": "view-libraries",
    "aka": [
      "UX Libraries",
      "UX Frameworks"
    ],
    "description": "View libraries render your app in the browser. You provide some code or data in a format that is specific to the library, and the library handles rendering DOM elements and styles. All of these run within the browser, but some also run on the server.",
    "count": 11,
    "type": "PROJECT"
  },
  {
    "name": "Learning Resources",
    "key": "learning-resources",
    "aka": [
      "educational repositories"
    ],
    "description": "These are GitHub projects that assist in learning JavaScript or related tools.",
    "count": 5,
    "type": "PROJECT"
  }
]


//////////////////
// WEBPACK FOOTER
// ./~/javascriptstuff-db/catalogue.js
// module id = 773
// module chunks = 84419135593297